import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Phone = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Phone({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.5 2.75C7.80964 2.75 7.25 3.30964 7.25 4V20C7.25 20.6904 7.80964 21.25 8.5 21.25H9.07426L9.44638 21.0655C9.80469 20.8878 10.1994 20.7955 10.5995 20.7955H13.4005C13.8006 20.7955 14.1953 20.8878 14.5536 21.0655L14.9257 21.25H15.5C16.1904 21.25 16.75 20.6904 16.75 20V4C16.75 3.30964 16.1904 2.75 15.5 2.75H14.9257L14.5864 2.91828C14.2067 3.10657 13.7885 3.20455 13.3647 3.20455H10.6353C10.2115 3.20455 9.79335 3.10657 9.41362 2.91828L9.07426 2.75H8.5ZM5.75 4C5.75 2.48122 6.98122 1.25 8.5 1.25H15.5C17.0188 1.25 18.25 2.48122 18.25 4V20C18.25 21.5188 17.0188 22.75 15.5 22.75H8.5C6.98122 22.75 5.75 21.5188 5.75 20V4Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'phone-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Phone;
